import React from "react";
import styled from "styled-components/macro";
import InternAdDoYouEnjoy from "./InternAdDoYouEnjoy";
import { shuffle } from "lodash";
import { useCounter } from "react-use";
import InternAdSets from "./InternAdSets";
import InternAdMotivation from "./InternAdMotivation";
import InternAdBlack from "./InternAdBlack";
import InternAdSunset from "./InternAdSunset";
import InternAdFlames from "./InternAdFlames";
import InternalAdPaywall from "./InternalAdPaywall";

const ads = [
  { name: "overview", Ad: InternalAdPaywall },
  { name: "doYouEnjoy", Ad: InternAdDoYouEnjoy },
  { name: "sets", Ad: InternAdSets },
  { name: "motivation", Ad: InternAdMotivation },
  { name: "black", Ad: InternAdBlack },
  { name: "sunset", Ad: InternAdSunset },
  { name: "flames", Ad: InternAdFlames }
];

const Wrap = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background: white;
`;

type Props = {
  open: boolean;
  onClose: VoidFunction;
};

const InternalAds: React.FC<Props> = ({ open, onClose }) => {
  const adsOrdered = React.useMemo(() => shuffle(ads), []);

  const [adsCounter, { inc: incAdsCounter }] = useCounter();

  const adIndex = adsCounter % adsOrdered.length;
  const Ad = adsOrdered[adIndex].Ad;

  const handleClose = () => {
    incAdsCounter();
    onClose();
  };

  if (!open) return null;

  return (
    <Wrap>
      <Ad onClose={() => handleClose()} />
    </Wrap>
  );
};

export default InternalAds;
